import { toastResponseErrors } from 'utils/responseErrorsHelper';

function parseAddress(geocodeResponse) {
  const { address_components, geometry } = geocodeResponse.results[0];
  const normalizedLatLng = {
    lat: typeof geometry?.location?.lat === 'function' ? geometry.location.lat() : geometry?.location?.lat,
    lng: typeof geometry?.location?.lng === 'function' ? geometry.location.lng() : geometry?.location?.lng,
  };
  const addressObj = {};
  address_components.forEach((addressComponent) => {
    addressComponent.types.forEach((type) => {
      addressObj[type] = addressComponent.short_name;
    });
  });
  return {
    latlng: normalizedLatLng,
    strNumber: addressObj.street_number,
    route: addressObj.route,
    city: addressObj.locality || addressObj.administrative_area_level_2, // level 2 for Brazil
    region: addressObj.administrative_area_level_1,
    countryKey: addressObj.country,
    zipcode: addressObj.postal_code,
  };
}

const toArray = (value) => (Array.isArray(value) ? value : [value]);

const getGeocoder = () => {
  if (!window?.google?.maps?.Geocoder) {
    throw new Error('Google Maps API is not loaded');
  }

  return new window.google.maps.Geocoder();
};

const geocode = (request) => new Promise((resolve, reject) => {
  getGeocoder().geocode(request, (results, status) => {
    if (status === 'OK' && results?.length) {
      resolve({ results });
      return;
    }

    reject(new Error(`Geocoder failed: ${status}`));
  });
});

const fromAddress = async (value) => {
  const [address] = toArray(value);
  return geocode({ address });
};

const fromLatLng = async (value) => {
  const [lat, lng] = toArray(value);
  return geocode({ location: { lat, lng } });
};

const call = (method) => async (args) => {
  try {
    const result = await method(args);
    return parseAddress(result);
  } catch (err) {
    toastResponseErrors({ error: err.message  });
    return { error: true };
  }
};


export default {
  fromAddress: call(fromAddress),
  fromLatLng: call(fromLatLng),
};
